import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// variables/keyframes.ts
init_react_import();
import { keyframes } from "styled-components";
var rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
var fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export {
  rotate,
  fadeIn
};
//# sourceMappingURL=chunk-VU2GL32S.mjs.map